import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {Object}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a settings icon (that looks like a gear).
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <SettingsIcon width={12} />
 */
const SettingsIcon = props => (
    <SvgIcon viewBoxSize={22} {...props}>
        <path
            d={`M40.874 24.058c.003-3.834 4.477-6.42
            4.477-6.42.628-.362.936-1.214.686-1.894l-.538-1.304c-.307-.655-1.13-1.04-1.83-.853
            0 0-4.993
            1.33-7.7-1.38-2.71-2.708-1.38-7.7-1.38-7.7.188-.7-.196-1.522-.85-1.83l-1.304-.54c-.68-.248-1.533.06-1.895.687
            0 0-2.59 4.473-6.422 4.473-3.83
            0-6.42-4.47-6.42-4.47-.36-.627-1.215-.937-1.895-.688l-1.303.54c-.656.306-1.04
            1.128-.853 1.828 0 0 1.332 4.988-1.375 7.7-2.712 2.706-7.702 1.378-7.702
            1.378-.7-.186-1.522.198-1.828.855l-.54 1.303c-.25.68.06 1.532.686 1.894 0
            0 4.473 2.586 4.473 6.417 0 3.834-4.475 6.423-4.475 6.423-.626.362-.935
            1.215-.686 1.894l.537 1.304c.307.656 1.13 1.04 1.83.852 0 0 4.992-1.332
            7.703 1.378 2.708 2.708 1.377 7.7 1.377 7.7-.186.7.197 1.524.853
            1.832l1.302.538c.68.25 1.532-.06 1.894-.685 0 0 2.59-4.477 6.42-4.477
            3.834.003 6.423 4.476 6.423 4.476.36.625 1.214.934
            1.894.685l1.303-.538c.655-.308 1.038-1.132.852-1.83 0 0-1.334-4.993
            1.375-7.7 2.71-2.71 7.702-1.38 7.702-1.38.7.186 1.523-.197
            1.83-.853l.54-1.304c.25-.68-.06-1.53-.687-1.893 0
            0-4.476-2.584-4.476-6.42zM24.116 35.244c-6.174 0-11.185-5.007-11.185-11.185
            0-6.18 5.012-11.19 11.187-11.19s11.186 5.008 11.186 11.19-5.01
            11.184-11.187 11.184z`}
        />
    </SvgIcon>
)

SettingsIcon.defaultProps = defaultProps

export { SettingsIcon }
